import { useEffect, useState } from 'react';
import { useWindowScroll, useWindowSize } from 'react-use';

import Flex from 'quarks/Flex';
import type { BasicProps } from 'quarks/interpolations/basic';

import type { FC } from 'react';

const ScrollTracker: FC<BasicProps> = props => {
  const { y: currentScrollPos } = useWindowScroll();
  const { height } = useWindowSize();
  const [scrollWidth, setScrollWidth] = useState(0);

  useEffect(() => {
    const wHeight = document.body.clientHeight;
    const wWidth = document.body.clientWidth;
    setScrollWidth((currentScrollPos / (wHeight - height)) * wWidth);
  }, [currentScrollPos]);

  return (
    <Flex
      position="fixed"
      left="0"
      top="var(--header-height, 100px)"
      md={{ top: 'var(--header-height, 124px)' }}
      height="8px"
      width="100%"
      zIndex="1"
      backgroundColor="gray-200"
      lg={{ top: 'var(--header-height, 74px)' }}
      before={{
        content: '',
        position: 'absolute',
        width: scrollWidth + 'px',
        height: '100%',
        top: 0,
        left: 0,
        backgroundColor: 'gray-900',
        transition: 'width 50ms ease-in-out',
      }}
      {...props}
    />
  );
};

export default ScrollTracker;
